export type NewsCategory = 'team' | 'results' | 'announcements' | 'tournaments' | 'interviews';
export type MediaType = 'stream' | 'match' | 'highlight' | 'screenshot' | 'photo';
export type Race = 'protoss' | 'terran' | 'zerg' | 'random';
export type PlayerRole = 'member' | 'officer' | 'leader';
export type ApplicationStatus = 'new' | 'accepted' | 'rejected' | 'archived';

export const NEWS_CATEGORIES: NewsCategory[] = ['team', 'results', 'announcements', 'tournaments', 'interviews'];
export const MEDIA_TYPES: MediaType[] = ['stream', 'match', 'highlight', 'screenshot', 'photo'];
export const RACES: Race[] = ['protoss', 'terran', 'zerg', 'random'];
export const PLAYER_ROLES: PlayerRole[] = ['member', 'officer', 'leader'];

export type NewsLink = { label: string; url: string };

export type News = {
  id: number;
  category: NewsCategory;
  title_ru: string;
  title_en: string | null;
  summary_ru: string | null;
  summary_en: string | null;
  body_ru: string | null;
  body_en: string | null;
  cover_url: string | null;
  gallery: string[];
  video_url: string | null;
  links: NewsLink[];
  published_at: string;
  is_published: boolean;
};

export type Achievement = {
  id: number;
  title_ru: string;
  title_en: string | null;
  event_date: string;
  mmr: string | null;
  place: string;
  source_url: string | null;
  vod_url: string | null;
  note_ru: string | null;
  note_en: string | null;
};

export type MediaItem = {
  id: number;
  title_ru: string;
  title_en: string | null;
  media_type: MediaType;
  url: string;
  preview_url: string | null;
  published_at: string;
};

export type PlayerShort = {
  id: number;
  nickname: string;
  race: Race;
  role: PlayerRole;
  mmr: number | null;
  avatar_url: string | null;
};

export type Roster = {
  id: number;
  name: string;
  mmr_min: number | null;
  mmr_max: number | null;
  description_ru: string | null;
  description_en: string | null;
  sort: number;
  players: PlayerShort[];
};

export type Player = PlayerShort & {
  roster_id: number | null;
  pulse_url: string | null;
  battle_tag: string | null;
  country: string | null;
  bio_ru: string | null;
  bio_en: string | null;
  twitch_url: string | null;
  youtube_url: string | null;
  sort: number;
  roster: { id: number; name: string; mmr_min: number | null; mmr_max: number | null } | null;
};

export type Application = {
  id: number;
  nickname: string;
  profile_url: string;
  mmr: number;
  timezone: string;
  contact: string;
  comment: string | null;
  status: ApplicationStatus;
  created_at: string;
};

export type LiveStream = {
  login: string;
  name: string;
  title: string;
  game: string;
  viewers: number;
  thumbnail: string;
  started_at: string;
  url: string;
  player_id: number | null;
  is_clan: boolean;
};

export type SessionUser = { id: string; email: string | null; isAdmin?: boolean };
